import script from "./LanguageSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageSelector.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageSelector.vue?vue&type=style&index=0&id=122d0e6d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-122d0e6d"]])

export default __exports__